//
//
//
//
//
//
//
//
//
import ArtistAvatar from '@/components/home/ArtistAvatar';
import Drip from 'drip';
export default {
  name: 'artist-list',
  components: {
    ArtistAvatar: ArtistAvatar
  },
  props: {
    list: {
      type: Array,
      default: []
    },
    isAbTest: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {};
  },
  methods: {
    handleItemClick: function handleItemClick(content) {
      var _ref = content || {},
          jumpUrl = _ref.jumpUrl,
          dataSeed = _ref.dataSeed;

      if (!jumpUrl) return;
      this.go(jumpUrl, {
        _blank: true
      });

      if (dataSeed) {
        window.seedAction(dataSeed);
      }
    }
  }
};